import React from 'react';
import { useLocation } from 'react-router-dom';

import bubble1 from '../../assets/background/bubble_1.png';
import bubble2 from '../../assets/background/bubble_2.png';
import bubble3 from '../../assets/background/bubble_3.png';
import bubble4 from '../../assets/background/bubble_4.png';
import bubble5 from '../../assets/background/bubble_5.png';
import bubble6 from '../../assets/background/bubble_6.png';
import bubble7 from '../../assets/background/bubble_7.png';

import { Container } from './styles';

const Background: React.FC = () => {
  const { pathname } = useLocation();

  const route = pathname.replace('/', '');

  return (
    <Container route={route}>
      <img src={bubble1} alt="Bubble" className="bubble bubble1" />
      <img src={bubble4} alt="Bubble" className="bubble bubble4" />
      <img src={bubble5} alt="Bubble" className="bubble bubble5" />
      <img src={bubble7} alt="Bubble" className="bubble bubble7" />

      {route !== 'contact' && (
        <img src={bubble2} alt="Bubble" className="bubble bubble2" />
      )}

      {route !== 'about' && route !== 'contact' && (
        <>
          <img src={bubble3} alt="Bubble" className="bubble bubble3" />
          <img src={bubble6} alt="Bubble" className="bubble bubble6" />
        </>
      )}
    </Container>
  );
};

export default Background;
